import React, { PropsWithChildren } from 'react';
import { LoadingSpinner } from '../../../components/atoms/LoadingSpinner';
import { isInvalid, SelectedImage } from '../../FileUpload/utils/validateImage';
import { ImageUploadValidationErrors } from './ImageUploadValidationErrors';

type PreviewSuspenseProps = {
  id: string;
  isLoading: boolean;
  selectedPreview: SelectedImage | undefined;
};

export function PreviewSuspense({ isLoading, children, selectedPreview, id }: PropsWithChildren<PreviewSuspenseProps>) {
  if (isLoading)
    return (
      <div className="image-gallery__loading">
        <div className="image-gallery__spinner">
          <LoadingSpinner />
        </div>
      </div>
    );

  if (isInvalid(selectedPreview)) {
    return <ImageUploadValidationErrors id={`image-upload-errors-${id}`} errors={selectedPreview.errors} />;
  }

  return <>{children}</>;
}
